import React, { FC, useCallback, useMemo, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { Menu } from "antd"
import { useSetState } from "@/reactUse"
import { menuItems, MenuRouteProps } from "@constants/menu"
import { TITLE } from "@constants/title"
import { useDashBoardModel, useUserModel } from "@/models"
import "./index.scss"

const LinkList = ["/", "/ncov", "/industrydb"]

const SubMenu = Menu.SubMenu
const MenuItem = Menu.Item

interface BIMenuState {
  theme: "dark" | "light"
  current: string
  link: string
  openKeys: string[]
}

const BIMenu: FC = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const user = useUserModel()
  const dashboard = useDashBoardModel()
  const [state, set] = useSetState<BIMenuState>({
    theme: "dark",
    current: pathname,
    link: "/",
    openKeys: [],
  })

  //根据路由动态设置title
  useEffect(() => {
    let firstPathName = "/" + pathname.split("/")[1]
    document.title = LinkList.includes(firstPathName)
      ? TITLE[firstPathName]
      : TITLE["/"]
  }, [pathname])

  const handleMenuClick = useCallback(
    e => {
      history.push(e.key)
      set({
        current: e.key,
      })
    },
    [set, history]
  )

  const handleOnOpenChange = useCallback(
    (openKeys: string[]) => {
      const latestOpenKey = openKeys.find(
        key => state.openKeys.indexOf(key) === -1
      )
      set({ openKeys: [latestOpenKey] })
    },
    [set, state.openKeys]
  )

  useEffect(() => {
    let current = pathname
    if (pathname.includes("ncov")) {
      current = "/ncov"
    } else if (pathname.includes("industrydb")) {
      current = "/industrydb"
    }
    set({ current })
  }, [set, pathname])

  useEffect(() => {
    if (user.userInfo.potoken) {
      dashboard.auquireBoardList()
    }
    // eslint-disable-next-line
  }, [user.userInfo.potoken, dashboard.auquireBoardList])

  const MenuItems = useMemo(() => {
    let myPanelList: MenuRouteProps[] = []
    let exampleList: MenuRouteProps[] = []

    dashboard.boardList.forEach(panel => {
      if (panel.source === 0) {
        myPanelList.push({
          key: `/panel/${panel.id}`,
          path: `/panel/${panel.id}`,
          title: `${panel.name}`,
        })
      } else {
        exampleList.push({
          key: `/panel/${panel.id}`,
          path: `/panel/${panel.id}`,
          title: `${panel.name}`,
        })
      }
    })

    let ms = menuItems.map(menu => {
      if (menu.key === "/panel/my") {
        menu.children = myPanelList
      } else if (menu.key === "/panel/example") {
        menu.children = exampleList
      }

      return menu
    })

    return ms.map(item => {
      if (item.children) {
        return (
          <SubMenu title={<span>{item.title}</span>} key={item.key}>
            {item.children.map(c => (
              <MenuItem key={c.key} title={c.title}>
                {c.title}
              </MenuItem>
            ))}
          </SubMenu>
        )
      } else {
        return (
          <MenuItem key={item.key} title={item.title}>
            <span>{item.title}</span>
          </MenuItem>
        )
      }
    })
  }, [dashboard.boardList])

  return (
    <div className="bi-menu flex">
      <Menu
        className="right"
        onClick={handleMenuClick}
        theme={state.theme}
        selectedKeys={[state.current]}
        openKeys={state.openKeys}
        onOpenChange={handleOnOpenChange}
        mode="inline"
        style={{
          height: "100%",
          maxWidth: "130px",
          width: "130px",
          backgroundColor: "#2B2C4A",
        }}
      >
        {MenuItems}
      </Menu>
    </div>
  )
}

export default BIMenu
